import React, { useCallback, useState } from "react";
import InsuranceMaterial from "../InsuranceMaterial";

/**
 * 事故资料指引覆盖层（由「事故维修-保险」下的「资料查看」打开）。
 * 统一管理显隐 / 覆盖层标题 / 渲染节点，供预约新建页、编辑页、预约详情页复用，
 * 避免三处各写一份 useState + 渲染。
 *
 * 用法：
 *   const { open, overlayTitle, node } = useInsuranceOverlay();
 *   // 入口：onClick={open}
 *   // 标题：useReserveStepDocumentTitle(step, overlayTitle)（详情页可忽略）
 *   // 渲染：{node}
 */
export default function useInsuranceOverlay() {
  const [visible, setVisible] = useState(false);

  const open = useCallback(() => setVisible(true), []);
  const close = useCallback(() => setVisible(false), []);

  // 覆盖层展示时的原生标题（关闭时为空串，交由调用方按步骤还原）
  const overlayTitle = visible ? "事故车所需资料指引" : "";

  const node = visible ? <InsuranceMaterial onClose={close} /> : null;

  return { visible, open, close, overlayTitle, node };
}
